<template>
    <div class="orderbar-challenge-select-user">
        <span class="orderbar-challenge-select-user__heading">SIRALA</span>
        <div class="wr-orderbar-challenge-select-user__buttons">
            <button
                v-for="ordertag in this.$store.state.ordertagsChallengeSelectUser" :key="ordertag.id"
                class="btn-ordertag-challenge-select-user"
                :class="ordertag.type === this.$store.state.selectedOrdertagChallengeSelectUser.type ? 'btn-ordertag-challenge-select-user__selected' : ''"
                @click="selectOrdertag(ordertag)">
                <span class="btn-ordertag-challenge-select-user__text">{{ ordertag.label }}</span>
            </button>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        methods: {
            selectOrdertag(ordertag){
                this.$store.commit('setSelectedOrdertagChallengeSelectUser', ordertag);
            }
        }
    };
</script>

<style scoped src="@/css/components/orderbar-challenge-select-user.css"></style>